import React from 'react';
import './AccountMenu.scss';
import { FaUserCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { logout } from '../services/auth.service';
import Button from './Button';

const AccountMenu: React.FC = () => {
  const handleLogout = async () => {
    await logout();
    window.location.href = '/';
  };

  return (
    <nav className="menu">
      <div className="menu-links">
        <Link to="/account/details" className="menu-item">
          <FaUserCircle className="icon-my-account" />
          <span>My Account</span>
        </Link>
        <Link to="/account/password">Password</Link>
        <Link to="/account/subscription">Subscription</Link>
        <Link to="/account/mfa">Multi-Factor Authentication</Link>
        <Link to="/defaults/theme">Default Theme</Link>
        <Link to="/account/terms-of-use">Terms of Use</Link>
        <Link to="/account/privacy-policy">Privacy Policy</Link>
      </div>
      <div className="menu-links">
        <Link to="/account/delete">Delete Account</Link>
        <Button onClick={handleLogout}>Logout</Button>
      </div>
    </nav>
  );
};

export default AccountMenu;
